import { render, staticRenderFns } from "./edition-public-list.vue?vue&type=template&id=4d78bc59&scoped=true&"
import script from "./edition-public-list.vue?vue&type=script&lang=ts&"
export * from "./edition-public-list.vue?vue&type=script&lang=ts&"
import style0 from "./edition-public-list.vue?vue&type=style&index=0&id=4d78bc59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78bc59",
  null
  
)

export default component.exports